import type React from 'react';
import { useEffect, useRef } from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: string | number;
  width?: string | number;
  height?: string | number;
  color?: string;
  fill?: string;
  stroke?: string;
}

export function ArrowRight(props: IconProps) {
  const root = useRef<SVGSVGElement>(null);
  const { size = '1em', width, height, color, fill, stroke, ...rest } = props;
  const _width = width || size;
  const _height = height || size;
  const _stroke = stroke || color;
  const _fill = fill || color;
  useEffect(() => {
    if (!_fill) {
      (root.current as SVGSVGElement)?.querySelectorAll('[data-follow-fill]').forEach((item) => {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }
    if (!_stroke) {
      (root.current as SVGSVGElement)?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return (
    <svg
      ref={root}
      width={_width}
      height={_height}
      viewBox="0 0 24 24"
      fill="none"
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M18 12.0039H6"
        data-follow-stroke="currentColor"
        fill="none"
        stroke={_stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12 6L18 12L12 18"
        data-follow-stroke="currentColor"
        fill="none"
        stroke={_stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
